import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './components/TestHotspotDemo'
import type { TestHotSpotDemoType } from './testHotspotTypes'

const TestHotspotDemo: TestHotSpotDemoType = ({ styles, feedback }) => (
  <DemoWrapper center>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.testHotspot.type}-demo`,
        type: CONFIG_ELEMENTS.testHotspot.type,
        value: {},
        font: {},
        style: {},
        feedback: {},
      }}
      feedback={feedback}
      styles={styles}
    />
  </DemoWrapper>
)

export default TestHotspotDemo
